export default "__VITE_ASSET__vvTq43ze__"